import { LogLevel } from "@azure/msal-browser";

import { baseUrl } from "./config";

export const msalConfig = {
    auth: {
        clientId: "9ecc6ebe-7faf-4496-b724-cc690d03b80c",
        authority: "https://login.microsoftonline.com/f08f9622-e392-4cc2-b1ae-ae004f002cf5",
        redirectUri: process.env.NODE_ENV === "production" ? `${baseUrl}` : "http://localhost:3000",
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error("cb:",message);
                        return;
                    case LogLevel.Info:
                        console.info("cb:",message);
                        return;
                    case LogLevel.Verbose:
                        console.debug("cb:",message);
                        return;
                    case LogLevel.Warning:
                        console.warn("cb:",message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

export const loginRequest = {
    scopes: ["user.read"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};